import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { postReservationSeriesFavorite } from '../../redux/actions';
import { convertDateToBackendFormat } from '../../commons';

class QuickReservation extends Component {
  reserveSpace = async (spaceId, lengthInDays) => {
    const { chosenDate } = this.props;
    const convertedChosenDate = convertDateToBackendFormat(chosenDate);
    const reservation = {
      startDate: convertedChosenDate,
      numberOfDays: lengthInDays,
    };
    return this.props.postReservationSeriesFavorite(reservation);
  };

  handleQuickReservation = async lengthInDays => {
    const { favorites, setMessage } = this.props;
    this.reserveSpace(favorites.spaceId, lengthInDays).then(res => {
      if (res && typeof res.serviceMessage === 'string') {
        setMessage('quickReservation.spaceBlocked');
      }
    });
  };

  render() {
    const { favorites, login, days, children, className } = this.props;
    return favorites && login ? (
      <button type="button" onClick={() => this.handleQuickReservation(days)} className={className}>
        {children}
      </button>
    ) : null;
  }
}

QuickReservation.propTypes = {
  postReservationSeriesFavorite: PropTypes.func.isRequired,
  setMessage: PropTypes.func,
  login: PropTypes.string,
  chosenDate: PropTypes.string.isRequired,
  favorites: PropTypes.shape({
    id: PropTypes.number,
    employee: PropTypes.string,
    endTime: PropTypes.string,
    preferredStartPage: PropTypes.string,
    spaceBackupId: PropTypes.number,
    spaceId: PropTypes.number,
    startTime: PropTypes.string,
  }),
  days: PropTypes.number,
  children: PropTypes.node,
  className: PropTypes.string,
};

QuickReservation.defaultProps = {
  setMessage: () => {},
  favorites: undefined,
  login: '',
  days: undefined,
  children: null,
  className: '',
};

const mapStateToProps = state => ({
  favorites: state.handleFavorites.favorites,
  chosenDate: state.handleDate.chosenDate,
  login: state.handleUser.user.login,
  reservations: state.handleReservations.reservations,
});

const mapDispatchToProps = {
  postReservationSeriesFavorite,
};

export default connect(mapStateToProps, mapDispatchToProps)(QuickReservation);
